export * from './email/email.validator';

/**
 * We don't check for string here so it also works with arrays
 * @returns {boolean}
 */
export function isEmptyInputValue(value) {
  return value === undefined || value === null || value.length === 0;
}
